import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const factorStatuses = async () => axios.get(Routes.FACTOR_STATUSES);

export const useFactorStatuses = () =>
  useQuery({
    queryKey: [Keys.FACTOR_STATUSES_QRY],
    queryFn: factorStatuses,
    cacheTime: 0,
  });
